import React from 'react';
import { DatoCmsBrandLogo, DatoCmsLink } from '../../../schema/datocms/blocks';

import Link from '../../link/link';
import ApiImageComponent from '../api-image/api-image-component';

const BrandLogoComponent = ({ links, apiImage }: DatoCmsBrandLogo): React.ReactElement => {
    const link: DatoCmsLink | undefined = links && links.length > 0 ? links[0] : undefined;

    let imageContent: JSX.Element | undefined = undefined;
    if (apiImage && apiImage[0]) {
        imageContent = (
            <ApiImageComponent apiImage={apiImage[0]} />
        );

        if (link && imageContent) {
            imageContent = (
                <Link
                    className="flex-shrink-0"
                    internalPageReference={link.internalPageReference}
                    internalPageSectionId={link.internalSectionComponentId}
                    externalPageUrl={link.externalPageUrl}
                    title={link.descriptiveTitle}
                >{imageContent}</Link>);
        }
    }
    const brandLogo = (
        <div>
            {imageContent}
        </div>
    );

    return brandLogo;
};

export default BrandLogoComponent;
